import { Company } from './company';

export const MANDATE_PENDING_ACCOUNT_ID_KEY = 'mandatePendingAccountId';
export const MANDATE_PENDING_F24_CREATION_KEY = 'mandatePendingF24Creation';

export const MandateQueryKeys = {
  all: ['Mandate'],
  status: (companyId: Company['id']) => ['Mandate', { companyId }, 'Status'],
};

export interface MandateStatus {
  canInitiatePayments: boolean;
  mandateEnabled: boolean;
  mandateExists: boolean;
  hasPendingF24RequiringMandate: boolean;
}

export interface InitiateMandatePayload {
  accountId: string;
}

export interface MandateInitiateResponse {
  consentUrl: string;
}
